export interface SpeechLanguage {
  code: string;
  label: string;
}

export const AZURE_SPEECH_LANGUAGES: SpeechLanguage[] = [
  { code: 'nl-NL', label: 'Nederlands' },
  { code: 'en-US', label: 'Engels (VS)' },
  { code: 'en-GB', label: 'Engels (VK)' },
  { code: 'de-DE', label: 'Duits' },
  { code: 'fr-FR', label: 'Frans' },
  { code: 'fr-BE', label: 'Frans (België)' },
  { code: 'es-ES', label: 'Spaans' },
  { code: 'pt-PT', label: 'Portugees' },
  { code: 'pt-BR', label: 'Portugees (Brazilië)' },
  { code: 'it-IT', label: 'Italiaans' },
  { code: 'pl-PL', label: 'Pools' },
  { code: 'tr-TR', label: 'Turks' },
  { code: 'ar-SA', label: 'Arabisch' },
  { code: 'ar-MA', label: 'Arabisch (Marokko)' },
  { code: 'zh-CN', label: 'Chinees (Mandarijn)' },
  { code: 'ja-JP', label: 'Japans' },
  { code: 'ko-KR', label: 'Koreaans' },
  { code: 'ru-RU', label: 'Russisch' },
  { code: 'uk-UA', label: 'Oekraïens' },
  { code: 'ro-RO', label: 'Roemeens' },
  { code: 'bg-BG', label: 'Bulgaars' },
  { code: 'cs-CZ', label: 'Tsjechisch' },
  { code: 'da-DK', label: 'Deens' },
  { code: 'fi-FI', label: 'Fins' },
  { code: 'el-GR', label: 'Grieks' },
  { code: 'hi-IN', label: 'Hindi' },
  { code: 'hu-HU', label: 'Hongaars' },
  { code: 'id-ID', label: 'Indonesisch' },
  { code: 'ms-MY', label: 'Maleis' },
  { code: 'nb-NO', label: 'Noors' },
  { code: 'sv-SE', label: 'Zweeds' },
  { code: 'th-TH', label: 'Thai' },
  { code: 'vi-VN', label: 'Vietnamees' },
  { code: 'he-IL', label: 'Hebreeuws' },
  { code: 'sr-RS', label: 'Servisch' },
  { code: 'hr-HR', label: 'Kroatisch' },
  { code: 'sk-SK', label: 'Slowaaks' },
  { code: 'sl-SI', label: 'Sloveens' },
  { code: 'ca-ES', label: 'Catalaans' },
  { code: 'eu-ES', label: 'Baskisch' },
  { code: 'gl-ES', label: 'Galicisch' },
  { code: 'cy-GB', label: 'Welsh' },
  { code: 'ga-IE', label: 'Iers' },
  { code: 'af-ZA', label: 'Afrikaans' },
  { code: 'sw-KE', label: 'Swahili' },
  { code: 'bn-IN', label: 'Bengaals' },
  { code: 'ta-IN', label: 'Tamil' },
  { code: 'te-IN', label: 'Telugu' },
  { code: 'ur-PK', label: 'Urdu' },
  { code: 'fa-IR', label: 'Perzisch' },
];

export const DEFAULT_SPEECH_LANGUAGE = AZURE_SPEECH_LANGUAGES[0]; // Nederlands
